<app-page-title icon="fa-user" title="Meus dados">
  <app-modal-twilio *ngIf="false"></app-modal-twilio>
</app-page-title>
<div class="card elevated">
  <app-skeleton *ngIf="loading" variant="text" [count]="8"
    label="Carregando o seu cadastro" data-testid="profile-loading"></app-skeleton>

  <form [formGroup]="userForm" class="card-body" (submit)="update()" *ngIf="!loading">
    <div class="alert alert-info" role="status" *ngIf="isMember" data-testid="profile-member-readonly">
      <i class="fa fa-lock"></i>
      Estes são os dados da conta. Só o proprietário pode alterá-los.
    </div>

    <div class="row mb-2">
      <div class="form-group col">
        <label for="name">Nome</label>
        <input
          data-testid="inpt-user-name"
          id="name"
          type="name"
          class="form-control"
          formControlName="name"
          autofocus
          #name
        />
        <span *ngIf="userForm.get('name').touched">
          <small
            data-testid="danger-name-mandatory"
            class="text text-danger"
            *ngIf="userForm.get('name').errors?.required"
          >
            Nome é obrigatório
          </small>
          <small
            data-testid="danger-min-length"
            class="text text-danger"
            *ngIf="userForm.get('name').errors?.minlength"
          >
            Nome deve ter ao menos 3 caracteres.
          </small>
        </span>
      </div>
      <div class="form-group col">
        <label>E-mail</label>
        <span class="form-control">{{ userForm.get('email').value }}</span>
      </div>
      <div class="form-group col">
        <label>Documento</label>
        <input type="text" id="document" class="form-control" formControlName="document" />
      </div>
  </div>
    <div class="row mb-2">
      <div class="form-group col">
        <label for="phone">Telefone</label>
        <input
          id="phone"
          type="text"
          class="form-control"
          appPhone
          formControlName="phone"
        />
      </div>
      <div class="form-group col">
        <label for="pix_key">Chave Pix</label>
        <input type="text" id="pix_key" class="form-control" formControlName="pix_key" />
      </div>
      <div class="form-group col">
        <label for="utm_source">UTM Source</label>
        <input
          id="utm_source"
          type="utm_source"
          class="form-control"
          formControlName="utm_source"
        />
      </div>

      <div class="col">
        <div class="form-group">
          <label for="operation">Modelo de negócio</label>
          <div>
            <select class="form-control" id="operation_type" formControlName="operation_type" >
              <option *ngFor="let operationType of operationTypes" [value]="operationType.value">{{ operationType.label }}</option>
            </select>
          </div>

          <small *ngIf="userForm.get('operation_type').errors?.required" class="text-danger">
            Preencha com o modelo de negócio
          </small>
        </div>
      </div>
      
    </div>
    <div class="row">
      <app-address [addressForm]="userForm"></app-address>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-checkbox
          [(ngModel)]="diffNF"
          [ngModelOptions]="{standalone: true}"
          [disabled]="isMember"
        >
          <span style="color: rgb(163, 163, 163);">
            Meus dados de faturamento são diferentes dos dados principais
          </span>
        </mat-checkbox>
      </div>
    </div>

    <div *ngIf="diffNF" class="row">
      <div class="col-md-12">
        <h2 class="my-3">Dados de faturamento</h2>
        <div class="row">
          <div class="col-sm-6">
            <label for="billing_document">CPF/CNPJ</label>
            <input type="text" (input)="formatCpfCnpj($event)" (change)="formatCpfCnpj($event)" maxlength="18" id="billing_document" required class="form-control" formControlName="billing_document" />
          </div>
          <div class="col-sm-6">
            <label for="billing_email">E-mail</label>
            <input type="text" id="billing_email" class="form-control" formControlName="billing_email" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">
            <label for="billing_company_name">Razão social</label>
            <input type="text" id="billing_company_name" class="form-control" formControlName="billing_company_name" />
          </div>
          <div class="col-md-4">
            <label for="billing_company_alias">Nome fantasia</label>
            <input type="text" id="billing_company_alias" class="form-control" formControlName="billing_company_alias" />
          </div>
          <div class="col-md-4">
            <label for="billing_im">Inscrição municipal</label>
            <input type="text" id="billing_im" class="form-control" formControlName="billing_im" />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-sm-6">
            <label for="billing_postcode">CEP</label>
            <input type="text" id="billing_postcode" (input)="cepChanged($event)" class="form-control" maxlength="9" formControlName="billing_postcode" />
            <small *ngIf="errorCEP" style="color: rgb(255, 77, 77);">Não foi possível puxar os dados do CEP automaticamente. Por favor, verifique se a numeração está correta.</small>
            
          </div>
          <div class="col-sm-6">
            <label for="billing_street">Endereço</label>
            <input type="text" id="billing_street" class="form-control" formControlName="billing_street" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-6">
            <label for="billing_number">Número</label>
            <input type="number" id="billing_number" class="form-control" formControlName="billing_number" />
          </div>
          <div class="col-sm-6">
            <label for="billing_complement">Complemento</label>
            <input type="text" id="billing_complement" class="form-control" formControlName="billing_complement" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">
            <label for="billing_district">Bairro</label>
            <input type="text" id="billing_district" class="form-control" formControlName="billing_district" />
          </div>
          <div class="col-md-4">
            <label for="billing_city">Cidade</label>
            <input type="text" id="billing_city" class="form-control" formControlName="billing_city" />
          </div>
          <div class="col-md-4">
            <label for="billing_state">Estado</label>
            <input type="text" id="billing_state" class="form-control" formControlName="billing_state" />
          </div>
        </div>
      </div>
    </div>

    <hr *ngIf="!isMember"/>

    <button *ngIf="!isMember" class="btn btn-primary" [appLoadingButton]="isSaving" data-testid="btn-user-save">
      Salvar
    </button>
  </form>
</div>

<!-- Verificação em duas etapas (CU-86ak84mj6) -->
<div class="card elevated mt-3" *ngIf="twoFactor">
  <div class="card-body">
    <h2 class="mb-3">Verificação em duas etapas</h2>

    <p class="two-factor-hint">
      Um código gerado pelo aplicativo autenticador (Google Authenticator, Authy,
      1Password) passa a ser pedido no login, além da senha. Assim, saber a sua
      senha deixa de ser suficiente para entrar na sua conta.
    </p>

    <div class="alert" [ngClass]="twoFactorNoticeClass" *ngIf="twoFactorNotice" data-testid="alert-2fa-notice">
      {{ twoFactorNotice }}
    </div>

    <div class="two-factor-switch mb-3" data-testid="switch-2fa">
      <app-switcher
        id="twoFactorSwitch"
        label="Ativado"
        [checked]="twoFactor.enabled"
        (checkedChange)="toggleTwoFactor()"
      ></app-switcher>
    </div>

    <p class="two-factor-hint" *ngIf="twoFactor.enabled && twoFactorStep === 'idle'">
      Ativada em {{ twoFactor.confirmed_at | date: 'dd/MM/yyyy' }} —
      {{ twoFactor.recovery_codes_remaining }} código(s) de recuperação restante(s).
      <a href="javascript:void(0)" (click)="twoFactorStep = 'recovery'" data-testid="link-2fa-new-codes">
        Gerar novos códigos
      </a>
    </p>

    <p class="two-factor-hint" *ngIf="twoFactor.enabled && twoFactorStep === 'idle'"
       data-testid="hint-2fa-no-self-disable">
      Trocou de celular ou perdeu o aplicativo? Fale com o Suporte — a
      verificação não pode ser desativada por aqui.
    </p>

    <!-- Ativação: senha → QR → primeiro código -->
    <div *ngIf="twoFactorStep === 'setup'">
      <div *ngIf="!twoFactorSetup">
        <div class="row mb-2">
          <div class="form-group col-md-4">
            <label for="twoFactorPassword">Confirme sua senha para continuar</label>
            <input type="password" class="form-control" id="twoFactorPassword"
              data-testid="input-2fa-password" [(ngModel)]="twoFactorPassword" />
          </div>
        </div>
        <button type="button" class="btn btn-primary" [appLoadingButton]="twoFactorBusy"
          (click)="requestTwoFactorSetup()" data-testid="btn-2fa-start">Continuar</button>
        <button type="button" class="btn btn-link" (click)="closeTwoFactorPanel()">Cancelar</button>
      </div>

      <div *ngIf="twoFactorSetup">
        <p>Leia o QR Code com o aplicativo autenticador e digite o código gerado:</p>

        <img [src]="twoFactorSetup.qr_code" alt="QR Code do autenticador" width="200" height="200" />

        <p class="mt-2">
          Ou cadastre a chave manualmente:
          <strong data-testid="text-2fa-secret">{{ twoFactorSetup.secret }}</strong>
        </p>

        <div class="row mb-2">
          <div class="form-group col-md-3">
            <label for="twoFactorCode">Código do autenticador</label>
            <input type="text" class="form-control" id="twoFactorCode" maxlength="6" inputmode="numeric"
              data-testid="input-2fa-code" [(ngModel)]="twoFactorCode" />
          </div>
        </div>

        <button type="button" class="btn btn-primary" [appLoadingButton]="twoFactorBusy"
          (click)="confirmTwoFactorSetup()" data-testid="btn-2fa-confirm">Ativar</button>
        <button type="button" class="btn btn-link" (click)="closeTwoFactorPanel()">Cancelar</button>
      </div>
    </div>


    <!-- Novos códigos de recuperação: não desativa nada. -->
    <div *ngIf="twoFactorStep === 'recovery'">
      <p class="two-factor-hint">
        Os códigos atuais deixam de valer assim que os novos forem gerados.
      </p>

      <div class="row mb-2">
        <div class="form-group col-md-4">
          <label for="twoFactorPasswordRecovery">Confirme sua senha</label>
          <input type="password" class="form-control" id="twoFactorPasswordRecovery"
            data-testid="input-2fa-password-recovery" [(ngModel)]="twoFactorPassword" />
        </div>
      </div>

      <button type="button" class="btn btn-primary" [appLoadingButton]="twoFactorBusy"
        (click)="regenerateRecoveryCodes()" data-testid="btn-2fa-regenerate">Gerar novos códigos</button>
      <button type="button" class="btn btn-link" (click)="closeTwoFactorPanel()">Cancelar</button>
    </div>

    <!-- Códigos de recuperação: exibidos uma única vez -->
    <div *ngIf="twoFactorStep === 'codes' && twoFactorRecoveryCodes">
      <p>
        Guarde os códigos de recuperação abaixo —
        <strong>eles não serão exibidos de novo</strong> e cada um vale uma única vez.
        Use um deles se perder o acesso ao aplicativo.
      </p>

      <ul data-testid="list-2fa-recovery-codes">
        <li *ngFor="let code of twoFactorRecoveryCodes"><code>{{ code }}</code></li>
      </ul>

      <!-- Sem um jeito de copiar, a pessoa transcreve à mão ou tira print da
           tela, que é pior do que o clipboard. -->
      <button type="button" class="btn btn-secondary" (click)="copyRecoveryCodes()"
        data-testid="btn-2fa-copy-codes">{{ recoveryCodesCopied ? 'Copiado!' : 'Copiar códigos' }}</button>
      <button type="button" class="btn btn-primary ms-2" (click)="closeTwoFactorPanel()"
        data-testid="btn-2fa-codes-ok">Já anotei</button>
    </div>

    <!-- `.error-password` só existe no LoginComponent, com encapsulamento de
         view: aqui a caixa saía sem padding nem borda. -->
    <div class="alert alert-danger mt-2" role="alert" *ngIf="twoFactorError">
      {{ twoFactorError }}
    </div>

    <div class="alert alert-warning mt-2" role="alert" *ngIf="twoFactorLoadError">
      Não foi possível carregar a verificação em duas etapas.
      <a href="javascript:void(0)" (click)="loadTwoFactorStatus()">Tentar de novo</a>
    </div>
  </div>
</div>

<!-- Token dos postbacks (CU-86ak8p7w0) -->
<div class="card elevated mt-3" data-testid="card-postback-token">
  <div class="card-body">
    <h2 class="mb-3">Token dos postbacks</h2>

    <p class="postback-token-hint">
      As URLs de integração e de listas que você copia no painel levam um token
      secreto. Com ele, só quem tem a URL consegue enviar leads e postbacks para a
      sua conta. Se uma URL vazou, gere um token novo.
    </p>

    <p class="postback-token-hint" *ngIf="postbackTokenState === 'loading'" data-testid="hint-postback-token-loading">
      Carregando…
    </p>

    <ng-container *ngIf="postbackTokenState === 'ready'">
      <p class="postback-token-hint" *ngIf="postbackToken.required" data-testid="hint-postback-token-required">
        Sua conta exige o token: postbacks e leads que chegam sem ele são recusados.
      </p>
      <p class="postback-token-hint" *ngIf="!postbackToken.required" data-testid="hint-postback-token-optional">
        Por enquanto sua conta ainda aceita as URLs antigas, sem token. As URLs do
        painel já saem com ele — use-as ao configurar ou trocar uma integração.
      </p>

      <!-- Trocar o token é do proprietário (`owner_only`): derruba as integrações da conta. -->
      <button *ngIf="!isMember" type="button" class="btn btn-primary" [disabled]="postbackTokenBusy"
        (click)="confirmRegeneratePostbackToken()" data-testid="btn-postback-token-regenerate">
        {{ postbackTokenBusy ? 'Gerando…' : 'Gerar token novo' }}
      </button>
    </ng-container>

    <div class="alert alert-warning mt-2" role="alert" *ngIf="postbackTokenState === 'unavailable'"
      data-testid="alert-postback-token-unavailable">
      Não foi possível carregar o token dos postbacks.
      <a href="javascript:void(0)" (click)="loadPostbackToken()">Tentar de novo</a>
    </div>
  </div>
</div>

<app-rcs-notify-prefs *ngIf="user?.rcs_enabled"></app-rcs-notify-prefs>
